import { editableFieldsInProduct, userInfo } from './../../../data/admin-master-data';
import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { PortalProductsService } from '../../../services/portal-products.service';

import { ConfirmDialog, OpenDialog } from '../../../shared/dialogs/dialog';
import { MaterialPageGrid } from '../../../utils/material-page-grid';
import { SuperAdminService } from '../../../services/super-admin.service';
import { AccountService } from '../../../services/account.service';
import { HttpService } from '../../../services/http.service';
import { AlertDialogComponent } from '../../../shared/dialogs/alert-dialog/alert-dialog.component';
@Component({
  selector: 'app-monitor-prd-signup',
  templateUrl: './monitor-prd-signup.component.html',
  styleUrls: ['./monitor-prd-signup.component.scss'],
})
export class MonitorPrdSignupComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  clientNotifyFieldsList = editableFieldsInProduct;

  resultsPageGrid: MaterialPageGrid;
  gridInProgress;
  prdStatusList = ['DRAFT', 'MODIFYING', 'SUBMITTED', 'APPROVAL_PENDING', 'APPROVED', 'COMPLETED'];
  departmentsList = ['ALL', 'CALS', 'CALI'];
  appList = ['PORTAL'];
  // prdStatus = new FormControl(['SUBMITTED']);
  notifiedFieldsList = [];
  prevIndex = null;
  prdInfo;
  prdSataInprogress: boolean;
  currentUser: any;
  videoStatusList = [];
  reviewPrdSignup;
  agentListMaster: any = [];
  pageSizes = [15, 20, 25, 30, 35, 40, 45, 50, 100];
  constructor(
    private fb: FormBuilder,
    private superAdminService: SuperAdminService,
    private portalProductsService: PortalProductsService,
    private accountService: AccountService,
    private httpService: HttpService,
    private cdRef: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    this.reviewPrdSignup = this.currentUser.priviledges.some((priviledge) => priviledge === 'REVIEW_PRODUCT_SIGNUP') || false;

    await this.initGrid();
  }

  ngAfterViewInit(): void {
    // Attach sort after view is initialized
    // Paginator is handled via template event binding (page)
    setTimeout(() => {
      if (this.resultsPageGrid && this.sort) {
        this.resultsPageGrid.attachSort(this.sort);
      }
    }, 0);
  }

  async initGrid() {
    this.resultsPageGrid = new MaterialPageGrid(this.fb, 15)
      .setTableColumns(['createdTime', 'lastUpdatedTime', 'customerData', 'status', 'actions'])
      .setSource(async (listQuery) => {
        try {
          this.gridInProgress = true;
          const dataList = await this.superAdminService.listPrdSignupsForDocumentOfficer({
            ...listQuery.filterValues,
            department:
              listQuery.filterValues.department && listQuery.filterValues.department.indexOf('ALL') >= 0
                ? ''
                : listQuery.filterValues.department,
            platform:
              listQuery.filterValues.platform && listQuery.filterValues.platform.indexOf('ALL') >= 0
                ? ''
                : listQuery.filterValues.platform || '',
            page: listQuery.pageIndex,
            size: listQuery.pageSize,
          });

          this.gridInProgress = false;
          return { data: dataList?.dataList || [], total: dataList?.dataCount || 0 };
        } catch (error) {
          this.gridInProgress = false;
          return { data: [], total: 0 };
        }
      })
      .setFilters({
        searchUsers: '',
        prdStatus: ['SUBMITTED'],
        platform: 'ALL',
        department: 'ALL',
      });

    // Ensure the default value is set after grid initialization
    setTimeout(() => {
      if (this.resultsPageGrid && this.resultsPageGrid.filtersForm) {
        // console.log('set value');
        this.resultsPageGrid.filtersForm.get('prdStatus').setValue(['SUBMITTED']);
      }
    }, 1000);

    this.resultsPageGrid.filtersForm.valueChanges.subscribe(async (value) => {
      console.log(value);
    });
    this.cdRef.detectChanges();
  }

  refreshGrid(userId?) {
    if (this.resultsPageGrid.filtersForm.get('searchUsers').value === userId) {
      this.resultsPageGrid.refreshData();
    } else {
      this.resultsPageGrid.filtersForm.get('searchUsers').setValue(userId, { emitEvent: true });
    }
  }

  // Action methods for the table
  viewDetails(element: any) {
    console.log('View details for:', element);
    // Implement view details logic
  }
}
